import React, { useState } from 'react';
import { AuthContext } from './auth';
import { REACT_APP_CLIENT_ID, REACT_APP_CLIENT_NAME } from '../data/data';

export const OfflineAuthProvider = ({ children }) => {

    const [userAuth, setUserAuth] = useState({
        nome: REACT_APP_CLIENT_NAME,
        sobrenome: '',
        email: '',
        perfilID: null,
        userID: 0,
        refreshToken: '',
        token: '',
        clientID: REACT_APP_CLIENT_ID,
        reloadMenu: false,
        accessToken: {
            headers: {}
        }
    });

    const [userMenu, setUserMenu] = useState();
    const [userNotification, setUserNotification] = useState([]);

    const [ativo, setAtivo] = useState({
        tagNum: '',
        tagDesc: '',
        tagID: 0,
        ativoID: 0,
        status: '',
        fabricante: '',
        modelo: '',
        ativo: false,
        tipoAtivo: '',
        numeroSerie: '',
    });

    return (
        <AuthContext.Provider
            value={{
                userAuth,
                setUserAuth,
                userMenu,
                setUserMenu,
                ativo,
                setAtivo,
                userNotification,
                setUserNotification
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};